import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '../../../components/ui/card';
import { Search } from 'lucide-react';

interface ProjectsTableHeaderProps {
  searchValue: string;
  onSearchChange: (value: string) => void;
}

export function ProjectsTableHeader({ searchValue, onSearchChange }: ProjectsTableHeaderProps) {
  return (
    <CardHeader>
      <div className="flex items-center justify-between">
        <CardTitle>All Practice Projects</CardTitle>
        <div className="relative w-64">
          <Search className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
          <Input
            placeholder="Quick search..."
            value={searchValue}
            onChange={(e) => onSearchChange(e.target.value)}
            className="pl-8"
          />
        </div>
      </div>
    </CardHeader>
  );
}
